<div class="search-box">
  <input
    type="text"
    placeholder="Search"
    [(ngModel)]="value"
    (keyup)="typed()"
  />
  <i class="fa fa-search"></i>
</div>
